// extracted by mini-css-extract-plugin
export default {"container":"FinderDetailsMobile_container__+VUKa"};